export const white = '#FFFFFF';
export const black = '#000000';
export const blueDianne = '#274457';
export const porcelain = '#F1F5F5';
export const alto = '#D6D6D6';
export const gallery = '#ECECEC';
export const gray = '#e3e3e3';
export const dodgerBlue = '#26B2FF';
